import React from 'react'
import showToast from '../SweetAlert/ToastAlert/index'
import { Box, Button, Typography, Grid } from '@mui/material'
import { ConfirmationAlert } from './ConfirmationAlert'
import { backgroundColors } from '../Color/Color'
import { fontSizes, fontWeights } from '../Typography/TypographyStyles'

interface ToastOption {
  icon: 'success' | 'error' | 'warning' | 'info'
  text: string
  label: string
}

const toastOptions: ToastOption[] = [
  {
    icon: 'success',
    text: 'Completed successfully!',
    label: 'Show Success Toast',
  },
  { icon: 'error', text: 'Something went wrong!', label: 'Show Error Toast' },
  {
    icon: 'warning',
    text: 'This is a warning message.',
    label: 'Show Warning Toast',
  },
  // eslint-disable-next-line quotes
  { icon: 'info', text: "Here's some information.", label: 'Show Info Toast' },
]

const SweetAlertPanel: React.FC = () => {
  return (
    <React.Fragment>
      <Box
        component='div'
        sx={{
          p: 0,
          backgroundColor: backgroundColors.white,
          width: 'auto',
          px: 1,
          py: 2,
        }}
        borderRadius={2}
        boxShadow={1}
      >
        <Box my={2}>
          <Typography sx={{ fontSize: fontSizes.size16, fontWeight: fontWeights[700] }} mb={2}>
            SweetAlert Toast
          </Typography>
          <Grid container spacing={2} direction='row'>
            {toastOptions.map((toast, index) => (
              <Grid key={index}>
                <Button color={toast.icon} onClick={() => showToast(toast.icon, toast.text)}>
                  {toast.label}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box my={2}>
          <Typography sx={{ fontSize: fontSizes.size16, fontWeight: fontWeights[700] }} mb={2}>
            SweetAlert Confirmation Message
          </Typography>
          <Grid container spacing={2} direction='row'>
            {toastOptions.map((toast, index) => (
              <Grid key={index}>
                <Button
                  color={toast.icon}
                  onClick={() =>
                    ConfirmationAlert({
                      title: `${toast.icon.toUpperCase()} Alert`,
                      text: `This shows a ${toast.icon} alert.`,
                      icon: toast.icon,
                    })
                  }
                >
                  {toast.label}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default SweetAlertPanel
